import { IPromise } from "angular";
import {
  IExpressionFunction,
  ITemplateScope,
  IValidator,
  IWatcher,
} from "AngularFormly";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../server/serverUtility";
import { UserProfile } from "../../../../../application/UserProfile";

interface UserAuthControllerScope extends ITemplateScope {
  onSelect: (item: UserProfile) => void;
  currentItems: UserProfile[];
  query: (search: string) => IPromise<UserProfile[]>;
  getUserDisplay(user: UserProfile): string;
  selectedItem?: UserProfile;
}

export interface SelectUserFieldConfig {
  key: string | number | undefined;
  name?: any;
  expressionProperties?:
    | { [key: string]: string | IExpressionFunction | IValidator }
    | undefined;
  label: string | undefined;
  hideExpression?: string | IExpressionFunction | undefined;
  watcher?: IWatcher | IWatcher[] | undefined;
  className?: string | undefined;
  initialItemSelector(model: any): UserProfile;
  onSelect?: (selectedItem: any, model: any) => void;
}

export class UserAuthController {
  static $inject = ["$scope", ServerUtilityName];

  constructor(
    private readonly $scope: UserAuthControllerScope,
    private readonly serverUtility: ServerUtility
  ) {
    $scope.currentItems = [];
    $scope.query = (search: string) => this.query(search);
    $scope.getUserDisplay = this.getUserDisplay;
    $scope.onSelect = this.onSelect.bind(this);
    //this isn't called by angular for some reason
    this.$onInit();
  }
  $onInit() {
    const model = this.$scope.model;
    const initialItem = this.$scope.model
      ? this.$scope.to.initialItemSelector(model)
      : undefined;

    if (initialItem === undefined) {
      return;
    }
    this.$scope.selectedItem = initialItem;
    this.$scope.currentItems = [initialItem];
  }

  onSelect(item: UserProfile) {
    this.$scope.selectedItem = item;
    this.$scope.to.onSelect(item, this.$scope.model);
  }

  query(search: string) {
    return this.serverUtility
      .query<UserProfile>({
        url: "/api/user",
        query: { NameContains: search, OrderBy: "LastName,FirstName" },
      })
      .then((results) => {
        return (this.$scope.currentItems = results.Results);
      });
  }

  getUserDisplay(user: UserProfile) {
    return `${user ? user.DisplayName ?? user.FirstName + user.LastName : ""}`;
  }
}
